module.exports = __webpack_public_path__ + "static/media/wincanton-logo.1e2d54ef.svg";